module.exports = __webpack_public_path__ + "static/img/color.85ea20f1.jpg";